import apiInstance from './apiInstance';

export const getTitleDetails = ({ config, propertyId }) => {
    const configDomain = config?.configDomain;
    const timeout = config?.timeouts?.small;
    const token = config?.token?.rpp;

    const url = `${configDomain}/property/${propertyId}/details`;

    return apiInstance.get({
        url, timeout, token,
    });
};

export const getProducts = ({ config }) => {
    const configDomain = config?.configDomain;
    const timeout = config?.timeouts?.small;
    const token = config?.token?.rpp;

    const url = `${configDomain}/products`;

    return apiInstance.get({
        url, timeout, token,
    });
};

export const postCreateOrder = ({ config, body }) => {
    const configDomain = config?.configDomain;
    const timeout = config?.timeouts?.small;
    const token = config?.token?.rpp;

    const url = `${configDomain}/order/create`;

    return apiInstance.post({
        url, timeout, token, body,
    });
};
